<template>
  <div
    v-loading="isLoading"
    class="vg_wrapper"
    element-loading-background="rgba(0, 0, 0, 0.8)"
    element-loading-spinner="el-icon-loading"
    element-loading-text="正在加载中"
  >
    <el-row>
      <el-col :span="24" style="margin-bottom: 20px; margin-top: 10px">
        <div class="diagramTitle">
          <span style="font-size: 20px; margin-right: 10px">统计时间:</span>
          <div class="dateSelect">
            <el-date-picker v-model="daytime[0]" type="date"> </el-date-picker>
            <span style="font-size: 20px">至</span>
            <el-date-picker v-model="daytime[1]" type="date"> </el-date-picker>
          </div>
          <el-button class="buttonText" round size="mini" @click="timeScope(1)">近一月</el-button>
          <el-button class="buttonText" round size="mini" @click="timeScope(3)">近三月</el-button>
          <el-button class="buttonText" round size="mini" @click="timeScope(6)">近六月</el-button>
          <el-button class="buttonText" round size="mini" @click="timeScope(0)">全部</el-button>
          <el-button class="buttonText" round size="mini" type="primary" @click="getTableData()">查询</el-button>
          <el-button class="buttonText" round size="mini" type="info" @click="refresh">刷新</el-button>
          <el-button
            v-if="['徐礼明', '盖新', 'Admin'].includes($cookies.get('userInfo').stff_name)"
            class="buttonText"
            round
            size="mini"
            type="warning"
            @click="dialogVisible = true"
            >基础分调整
          </el-button>
          <el-button class="buttonText" round size="mini" type="success" @click="exportToExcel">导出Excel</el-button>
        </div>
      </el-col>
    </el-row>
    <el-row>
      <search-table
        ref="searchTable"
        :columnMove="false"
        :columns="syncTableProperties"
        :data="tableData"
        :need-pagination="false"
        :tableRowKey="'id'"
        @getTableData="getTableData"
      >
      </search-table>
    </el-row>
    <el-dialog :visible.sync="dialogVisible" title="基数超产奖调整" top="50px" width="40%" @opened="getDialogData">
      <search-table
        ref="searchTable"
        :columnMove="false"
        :columns="dialogTableProperties"
        :data="dialogTableData"
        :fixedHeightParam="400"
        :need-fixed-height="false"
        :need-pagination="false"
        :need-search="false"
        :tableRowKey="'id'"
      />
      <div class="vg_mt_8" style="display: flex">
        <el-button class="buttonText" round size="mini" style="margin-left: auto" type="success" @click="editDiffListData">确定 </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import SearchTable from '@/components/SearchTableV3.vue';
import { cloneDeep } from 'lodash';
import { keep1Decimal, keep3Decimal, keepNumber } from '@assets/js/regExUtil';
import { get, getNoCatch, postNoCatch } from '@api/request';
import { dataStaticsAPI } from '@api/modules/stat';
import {
  dialogTablePropertiesBaoJia,
  dialogTablePropertiesBeiLiao,
  dialogTablePropertiesDianXiu,
  dialogTablePropertiesFuHe,
  dialogTablePropertiesJianYan,
  dialogTablePropertiesJiFeng,
  dialogTablePropertiesJiGuang,
  dialogTablePropertiesKaiBan,
  dialogTablePropertiesRuKu,
  dialogTablePropertiesShouCai,
  dialogTablePropertiesShouGong,
  dialogTablePropertiesYinHua,
  dialogTablePropertiesZhiKa
} from '@/views/DataStatistics/ProductValueYieldStatisticsYangZhou/TabChild/per';

export default {
  components: { SearchTable },
  name: 'CorrectionStatistics',
  props: {
    module: {
      type: String
    },
    loading: {
      type: Boolean
    }
  },
  data() {
    return {
      dialogVisible: false,
      syncTableProperties: [
        { prop: 'index', type: 'index', labelWidth: '50px', label: '序号' },
        { label: '员工姓名', prop: 'stff_name', itemType: 'input', input: false, sortable: false, widthAuto: true },
        { label: '基数产值', prop: 'base_output', itemType: 'input', input: false, sortable: false, widthAuto: true },
        { label: '超产奖', prop: 'over_bonus', itemType: 'input', input: false, sortable: false, widthAuto: true },
        { label: '总产值', prop: 'total_output', itemType: 'input', input: false, sortable: false, widthAuto: true },
        { label: '额外得分', prop: 'extra_score', itemType: 'input', input: false, sortable: false, widthAuto: true }
      ],
      dialogTableProperties: cloneDeep(dialogTablePropertiesKaiBan),
      dialogTableData: [],
      tableData: [],
      selectionsList: [],
      startTime: null,
      endTime: null,
      daytime: '',
      isLoading: this.loading
    };
  },
  computed: {},
  watch: {
    // 监听时间范围变化 加载数据
    daytime(newValue, oldValue) {
      let { startTime, endTime } = this.helper.getTime(newValue);
      this.startTime = startTime;
      this.endTime = endTime;
      this.getTableData();
    }
  },
  mounted() {
    this.timeScope(1);
  },
  methods: {
    keep3Decimal,
    keepNumber,
    keep1Decimal,
    initData() {
      this.getTableData();
    },
    getSearchForm(type) {
      let searchForm = cloneDeep(this.$refs.searchTable.searchForm);
      searchForm.type = type;
      const [startTime, endTime] = cloneDeep(this.daytime || []);
      // 确保时间戳被正确赋值且进行单位转换（如果需要）
      searchForm.start_time = startTime ? Math.floor(startTime / 1000) : null;
      let secondDate = new Date(endTime);
      secondDate.setHours(23, 59, 59, 999);
      searchForm.end_time = endTime ? Math.floor(secondDate.getTime() / 1000) : null;
      searchForm.module = this.module;
      searchForm.dept_name = this.$cookies.get('userInfo').dept_name;
      return searchForm;
    },
    getTableData() {
      this.isLoading = true;
      get(dataStaticsAPI.getWorkPerformanceStatistics, this.getSearchForm(false)).then(({ data }) => {
        if (data.code === 0) {
          this.tableData = data.data.list;
          this.isLoading = false;
        }
      });
    },
    refresh() {
      this.startTime = null;
      this.endTime = null;
      this.daytime = '';
      this.initData();
    },
    // 导出excel
    exportToExcel() {
      getNoCatch(dataStaticsAPI.getWorkPerformanceStatistics, this.getSearchForm(true)).then(({ data }) => {
        this.helper.downloadItemExcel(data.url, data.fileName);
      });
    },
    getDialogData() {
      switch (this.module) {
        case '开版':
          this.dialogTableProperties = cloneDeep(dialogTablePropertiesKaiBan);
          break;
        case '印花':
          this.dialogTableProperties = cloneDeep(dialogTablePropertiesYinHua);
          break;
        case '制卡':
          this.dialogTableProperties = cloneDeep(dialogTablePropertiesZhiKa);
          break;
        case '激光':
          this.dialogTableProperties = cloneDeep(dialogTablePropertiesJiGuang);
          break;
        case '电绣':
          this.dialogTableProperties = cloneDeep(dialogTablePropertiesDianXiu);
          break;
        case '手裁':
          this.dialogTableProperties = cloneDeep(dialogTablePropertiesShouCai);
          break;
        case '备料':
          this.dialogTableProperties = cloneDeep(dialogTablePropertiesBeiLiao);
          break;
        case '复合':
          this.dialogTableProperties = cloneDeep(dialogTablePropertiesFuHe);
          break;
        case '机缝':
          this.dialogTableProperties = cloneDeep(dialogTablePropertiesJiFeng);
          break;
        case '手工':
          this.dialogTableProperties = cloneDeep(dialogTablePropertiesShouGong);
          break;
        case '检验':
          this.dialogTableProperties = cloneDeep(dialogTablePropertiesJianYan);
          break;
        case '入库':
          this.dialogTableProperties = cloneDeep(dialogTablePropertiesRuKu);
          break;
        case '报价':
          this.dialogTableProperties = cloneDeep(dialogTablePropertiesBaoJia);
          break;
      }
      this.getDiffListData(this.module);
    },
    getDiffListData(val) {
      getNoCatch(dataStaticsAPI.getBasicgetWorkPerformanceStatistics, {
        saml_product: val,
        belo_dept_id: this.$cookies.get('userInfo').dept_id
      }).then(({ data }) => {
        this.dialogTableData = data;
      });
    },
    editDiffListData() {
      let data = cloneDeep(this.dialogTableData);
      postNoCatch(dataStaticsAPI.editBasicgetWorkPerformanceStatistics, data).then(({ data }) => {
        this.dialogVisible = false;
        this.$message.success('操作成功!');
      });
    },
    timeScope(val) {
      let firstDate = new Date();
      firstDate.setMonth(firstDate.getMonth() - val);
      firstDate.setHours(0, 0, 0, 0);
      let secondDate = new Date();
      secondDate.setDate(25);
      secondDate.setHours(23, 59, 59, 999);
      this.daytime = val === 0 ? [] : [Math.floor(firstDate.getTime()), Math.floor(secondDate.getTime())];
      this.getTableData();
    }
  }
};
</script>

<style scoped>
.diagramTitle {
  display: flex;
  align-items: center;
}

.dateSelect {
  display: flex;
  align-items: center;
  margin-right: 10px;
}

.buttonText {
  font-size: 18px;
}
</style>
